/* 特集LP（sections/main-feature-lp.liquid）専用：ページ内リンクのスクロールと、スマホ下部の「商品を見る」ボタン */
(function(){
  var root = document.querySelector('.flp'); if (!root) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 画面上に固定・追従しているヘッダーの高さ */
  function headH(){
    var t = 0;
    ['.wh-bar', 'header.wh'].forEach(function(sel){
      var el = document.querySelector(sel); if (!el || !el.offsetHeight) return;
      var p = getComputedStyle(el).position;
      if (p === 'fixed' || p === 'sticky') t += el.offsetHeight;
    });
    return t;
  }

  /* ページ内リンク（#flp-shop など）はヘッダーの高さを引いてスクロール */
  root.addEventListener('click', function(e){
    var a = e.target.closest ? e.target.closest('a[data-flp-jump]') : null; if (!a) return;
    var h = a.getAttribute('href') || '';
    if (h.charAt(0) !== '#' || h.length < 2) return;
    var t = document.getElementById(h.slice(1)); if (!t) return;
    e.preventDefault();
    var y = t.getBoundingClientRect().top + window.pageYOffset - headH() - 12;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', h);
  });

  /* スマホ下部のボタン：メインビジュアルを過ぎたら出す。商品一覧・締め・フッターが見えている間は隠す */
  var st = root.querySelector('[data-flp-sticky]');
  var hero = root.querySelector('.xlf-hero');
  if (!st || !hero || !('IntersectionObserver' in window)) return;
  var heroOut = false, hide = {};
  function upd(){
    var on = heroOut;
    for (var k in hide){ if (hide[k]) on = false; }
    st.classList.toggle('is-on', on);
    st.setAttribute('aria-hidden', on ? 'false' : 'true');
    st.tabIndex = on ? 0 : -1;
  }
  new IntersectionObserver(function(es){ heroOut = !es[es.length - 1].isIntersecting; upd(); }).observe(hero);
  [['shop', root.querySelector('[data-flp-shop]')], ['end', root.querySelector('.flp-end')], ['foot', document.querySelector('footer.wf')]].forEach(function(p){
    if (!p[1]) return;
    new IntersectionObserver(function(es){ hide[p[0]] = es[es.length - 1].isIntersecting; upd(); }, { rootMargin: '0px 0px -25% 0px' }).observe(p[1]);
  });
})();
